import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

const isGoogleConfigured = Boolean(process.env.REACT_APP_GOOGLE_CLIENT_ID);

const GoogleAuthButton = ({ textVariant = 'continue_with', onSuccess }) => {
  const { loginWithGoogle } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!isGoogleConfigured) {
    return null;
  }

  const handleSuccess = async (credentialResponse) => {
    if (!credentialResponse.credential) {
      toast.error('Unable to read Google credential');
      return;
    }

    setLoading(true);
    const result = await loginWithGoogle(credentialResponse.credential);
    setLoading(false);

    if (result.success) {
      toast.success('Signed in with Google');
      onSuccess?.();
    } else {
      // Handle inactive account with longer duration and specific message
      if (result.message === 'ACCOUNT_INACTIVE') {
        const inactiveMessage = result.error || 'Your account is currently inactive. Please contact support to reactivate your account.';
        toast.error(inactiveMessage, { duration: 6000 });
      } else {
        toast.error(result.message || 'Google sign-in failed');
      }
    }
  };

  const handleError = () => {
    toast.error('Google sign-in was cancelled or failed');
  };

  return (
    <div className="relative flex justify-center">
      {loading && (
        <div className="absolute inset-0 bg-white/80 rounded-full flex items-center justify-center z-10">
          <Loader2 className="h-5 w-5 text-purple-600 animate-spin" />
        </div>
      )}
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        shape="pill"
        theme="outline"
        size="large"
        width="100%"
        text={textVariant}
      />
    </div>
  );
};

export default GoogleAuthButton;


